import GradeHorarios from './components/GradeHorarios'
import FrequenciaNotas from './components/FrequenciaNotas'
import BoletinsPareceres from './components/BoletinsPareceres'
import AtestadoMatricula from './components/AtestadoMatricula'
import AtestadoTrancamento from './components/AtestadoTrancamento'
import DisciplinasCursadas from './components/DisciplinasCursadas'

export default [
  {
    path: '/academico/grade-horarios',
    component: GradeHorarios,
    name: 'academico.grade-horarios',
    meta: {
      breadcrumb: {
        name: 'Grade de Horários'
      }
    }
  },
  {
    path: '/academico/frequencia-notas',
    component: FrequenciaNotas,
    name: 'academico.frequencia-notas',
    meta: {
      breadcrumb: {
        name: 'Frequências e Notas'
      }
    }
  },
  {
    path: '/academico/boletins-pareceres',
    component: BoletinsPareceres,
    name: 'academico.boletins-pareceres',
    meta: {
      breadcrumb: {
        name: 'Boletins e Pareceres'
      }
    }
  },
  {
    path: '/academico/atestado-matricula',
    component: AtestadoMatricula,
    name: 'academico.atestado-matricula',
    meta: {
      breadcrumb: {
        name: 'Atestado de Matrícula'
      }
    }
  },
  {
    path: '/academico/atestado-trancamento',
    component: AtestadoTrancamento,
    name: 'academico.atestado-trancamento',
    meta: {
      breadcrumb: {
        name: 'Atestado de trancamento'
      }
    }
  },
  {
    path: '/academico/disciplinas-cursadas',
    component: DisciplinasCursadas,
    name: 'academico.disciplinas-cursadas',
    meta: {
      breadcrumb: {
        name: 'Disciplinas Cursadas'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/app/domains/academico/routes.js